module.exports = __webpack_public_path__ + "static/media/strongher2.e06d23a0.jpg";